import React from 'react'
import TermsContent from '../../components/Terms/TermsContent.jsx'
import PropTypes from 'prop-types'
import Skeleton from '../UI/Skeleton.jsx'

class TermsCard extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            terms: [],
        }
    }

    componentWillMount() {
        if (!this.props.skeleton) {
            let terms = this.props.terms
            terms.sort((a, b) => a.name.localeCompare(b.name))
            this.setState({ terms })
        }
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <div className="terms-post col-12">
                            <div className="terms-content">
                                <div className="terms-char xl-font-size"><Skeleton width={'5%'} /></div>
                                <div><TermsContent skeleton={true} /></div>
                            </div>
                        </div>
                        :
                        <div className="terms-post col-12" id={`term-${this.props.id}`}>
                            <div className="terms-content">
                                <div className="terms-char xl-font-size">{this.props.char}</div>
                                <div>
                                    {this.state.terms.map((term) => (
                                        <TermsContent
                                            key={term.id}
                                            id={term.id}
                                            name={term.name}
                                            desc={term.desc}
                                            props={this.props}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                }
            </React.Fragment>
        )
    }
}

TermsCard.propTypes = {
    id: PropTypes.number,
    char: PropTypes.string,
    terms: PropTypes.array,
    skeleton: PropTypes.bool,
}

export default TermsCard



// WEBPACK FOOTER //
// ./src/components/Terms/TermsCard.jsx